import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSellerBanner, deleteSellerBanner, fetchSellerBanners, updateSellerBanner } from "./sellerBannersApi";

export const fetchSellerBannersThunk = createAsyncThunk(
    "seller-banners/fetchAll", 
    async (sellerId, { rejectWithValue }) => {
    try {
        const data = await fetchSellerBanners(sellerId);
        return Array.isArray(data) ? data : data.banners || [];
    } catch (error) {
        return rejectWithValue(error.message || "Failed to fetch banners");
    }
});

export const createSellerBannerThunk = createAsyncThunk(
    "seller-banners/create",
    async (payload, { rejectWithValue }) => {
        try {
            return await createSellerBanner(payload);
        } catch (error) {
            return rejectWithValue(error.message || "Failed to create banner");
        }
    }
);


export const updateSellerBannerThunk = createAsyncThunk(
    "seller-banners/update",
    async (payload, { rejectWithValue }) => {
        try {
            return await updateSellerBanner(payload);
        } catch (error) {
            return rejectWithValue(error.message || "Failed to update banner");
        }
    }
);


export const deleteSellerBannerThunk = createAsyncThunk(
    "seller-banners/delete",
    async (bannerId, { rejectWithValue }) => {
        try {
            return await deleteSellerBanner(bannerId);
        } catch (error) {
            return rejectWithValue(error.message || "Failed to create banner");
        }
    }
);